// Logout.jsx
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "./useAuth";

export default function Logout() {
  const { logout } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    (async () => {
      await logout();      // ← ストレージ・状態クリア
      navigate("/");       // ← ログインページなどへ戻す
    })();
  }, [logout, navigate]);

  return <div>ログアウト中...</div>;
}
